import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'heroScreenImagePath',
  initialState: null as string | null,
  reducers: {
    setHeroScreenImagePath(state, action: PayloadAction<string>) {
      return action.payload || null;
    },
  },
});

export const { setHeroScreenImagePath } = slice.actions;

export default slice.reducer;
